import Helper from '@ember/component/helper';
import { isArray } from '@ember/array';
import { assert } from '@ember/debug';
import { service } from '@ember/service';
import { capitalize as capitalizeString } from '@ember/string';
import ProgressionDescription from '@linc-technologies/linced-common/enums/progression-descriptions';

export default class ProgressionDescriptionLabel extends Helper {
  @service
  strings;

  compute(params, options) {
    if (!isArray(params) || params.length < 1) {
      // No positional param passed; return an empty string.
      return '';
    }

    return getProgressionDescriptionLabel(
      params[0],
      options,
      options.strings ?? this.strings,
    );
  }
}

export function getProgressionDescriptionLabel(
  description,
  { capitalize },
  strings,
) {
  let label = '';

  switch (description) {
    case ProgressionDescription.ONE:
      label = strings.progressWellBelowDesc;
      break;
    case ProgressionDescription.TWO:
      label = strings.progressBelowDesc;
      break;
    case ProgressionDescription.THREE:
      label = strings.progressAtDesc;
      break;
    case ProgressionDescription.FOUR:
      label = strings.progressAboveDesc;
      break;
    case ProgressionDescription.FIVE:
      label = strings.progressWellAboveDesc;
      break;
  }

  // linced-parents has no progress descriptions on its strings service, as
  // they change with the learner school. Pass strings= from
  // strings.getProgressStrings(school) there.
  assert(
    `progression-description-label: strings has no label for description ${description}. Pass strings= with the progress strings of the school.`,
    typeof label === 'string',
  );
  // A production build has no assert. Render nothing, not a render error.
  label ??= '';

  if (capitalize) {
    label = capitalizeString(label);
  }

  return label;
}
